import React from 'react';
import classes from '../RelatedRooms.module.scss';
import cn from 'classnames';
import { IDocument } from 'interfaces';
import { useTranslation } from 'react-i18next';
import ReferrinRoomRow from './ReferrinRoomRow';


type ReferringRoomsType = {
  referringRooms: IDocument[];
  setModalTermOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTerm: React.Dispatch<React.SetStateAction<IDocument | null>>;
};

const ReferringRooms = ({
  referringRooms,
  setModalTermOpen,
  setSelectedTerm,
}: ReferringRoomsType) => {
  const { t } = useTranslation();
  
  return (
    <div className={cn(classes.relatedRoomsWrap)}>
      <div className={cn(classes.relatedRoomsTitle, classes.cantEdit)}>
        <div>
          {t('Settings.relatedRooms.referringRoomName')}
        </div>
        <div>
          {t('Settings.relatedRooms.termTitle')}
        </div>
      </div>
      {referringRooms.map((term, i) => (
        <ReferrinRoomRow
          key={term.id}
          document={term}
          setIsOpen={setModalTermOpen}
          setSelectedTerm={setSelectedTerm}
        />
      ))}
    </div>
  );
}

export default ReferringRooms;
